var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('tickets-list',{attrs:{"stats":false,"defaultQuery":_vm.query,"title":"Relaterade ärenden"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }